<template>
    <div ref="dropdown" class="dropdown" @click="toggleDropdown">
        <button
            class="btn"
            :class="[styleType, { 'btn-left-radius-0': isPartofGroupBtn }]"
        >
            <slot name="button-content">{{ btnContent }}</slot>
            <i v-if="!noCaret" class="fa fa-caret-down ml-1"></i>
        </button>
        <div
            class="dropdown-content py-2"
            :class="{ show: isDropdownVisible, 'dropdown-menu-right': right }"
            id="myDropdown"
        >
            <slot>
                <dropdown-item
                    v-for="(item, index) in itemList"
                    :key="index"
                    :label="item.label"
                    @select="selectItem(item)"
                >
                </dropdown-item>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        DropdownItem: () => import("@/components/commons/dropdown-item.vue")
    },
    props: {
        btnContent: {
            type: String,
            default: null,
            required: false
        },
        itemList: {
            type: Array,
            default: () => [{ value: null, label: "" }],
            required: false
        },
        variant: {
            type: String,
            default: "secondary",
            validator(value) {
                return [
                    "success",
                    "secondary",
                    "success",
                    "danger",
                    "warning",
                    "info",
                    "light",
                    "dark",
                    "link",
                    "primary"
                ].includes(value);
            }
        },
        noCaret: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        },
        isPartofGroupBtn: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        styleType() {
            return `btn-${this.variant}`;
        }
    },
    data() {
        return {
            isDropdownVisible: false
        };
    },
    methods: {
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible;
            if (this.isDropdownVisible) {
                document.addEventListener("click", this.handleClickOutside);
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        selectItem(item) {
            setTimeout(() => {
                this.isDropdownVisible = false;
            }, 0);
            this.$emit("selected", item);
        },
        handleClickOutside(event) {
            if (!this.$refs.dropdown.contains(event.target)) {
                setTimeout(() => {
                    this.isDropdownVisible = false;
                }, 0);
                document.removeEventListener("click", this.handleClickOutside);
            }
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    }
};
</script>

<style>
.dropdown-content {
    display: none;
    position: absolute;
    background-color: white;
    min-width: 160px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    z-index: 1;
    margin-top: 1px;
}

.dropdown-content a {
    color: black;
    padding: 8px 12px;
    text-decoration: none;
    display: block;
    font-size: 14px;
    transition: background-color 0.3s;
}

.dropdown-content a:hover {
    background-color: #f1f1f1;
}

.show {
    display: block;
}

.dropdown-menu-right {
    right: 0;
    left: auto;
}

.btn-left-radius-0 {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}
</style>
